import e, { Component as t } from "react";
import n from "react-dom";
import { InputText as r } from "../InputText/InputText.js";
import a from "../../../../node_modules/classnames/index.js";
import { FormLabel as o } from "../Label/FormLabel.js";
import { Button as i } from "../../buttons/Button/Button.js";
import { CalendarPanel as s } from "./CalendarPanel.js";
import l from "../../../utils/DomHandler.js";
import { tip as p } from "../Tooltip/Tooltip.js";
import { Ripple as u } from "../Ripple/Ripple.js";
import c from "../../../utils/UniqueComponentId.js";
import d from "../../../utils/ConnectedOverlayScrollHandler.js";
import { localeOption as m, localeOptions as g } from "../../api/Locale.js";
import { Icon as f } from "../../general/Icon/Icon.js";
import v from "../../../../node_modules/react-transition-group/esm/CSSTransition.js";
function D(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function h(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function M(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function y(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function k(e) {
  return (k = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function w(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {},
      r = Object.keys(n);
    "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
      return Object.getOwnPropertyDescriptor(n, e).enumerable;
    }))), r.forEach(function (t) {
      y(e, t, n[t]);
    });
  }
  return e;
}
function b(e, t) {
  return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : function (e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      n.push.apply(n, r);
    }
    return n;
  }(Object(t)).forEach(function (n) {
    Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
  }), e;
}
function S(e, t) {
  return (S = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
function E(e) {
  return function (e) {
    if (Array.isArray(e)) return D(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || function (e, t) {
    if (e) {
      if ("string" == typeof e) return D(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      if ("Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n) return Array.from(n);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return D(e, t);
    }
  }(e) || function () {
    throw TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
(T = C || (C = {}))[T.Hour = 0] = "Hour", T[T.Minute = 1] = "Minute", T[T.Second = 2] = "Second", T[T.MiliSecond = 3] = "MiliSecond", (x = F || (F = {}))[x.Up = 1] = "Up", x[x.Down = -1] = "Down";
var T,
  x,
  C,
  F,
  I = function (t) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && S(e, t);
    }(F, t);
    var D,
      T,
      x,
      C = (D = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }(), function () {
        var e,
          t,
          n = k(F);
        if (D) {
          var r = k(this).constructor;
          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);
        return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : h(this);
      });
    function F(t) {
      if (!function (e, t) {
        if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
      }(this, F), y(h(D = C.call(this, t)), "navigation", void 0), y(h(D), "id", void 0), y(h(D), "inputElement", void 0), y(h(D), "tooltip", void 0), y(h(D), "viewStateChanged", void 0), y(h(D), "panel", void 0), y(h(D), "mask", void 0), y(h(D), "scrollHandler", void 0), y(h(D), "ignoreFocusFunctionality", void 0), y(h(D), "isKeydown", void 0), y(h(D), "view", void 0), y(h(D), "timePickerTimer", void 0), y(h(D), "documentClickListener", void 0), y(h(D), "documentResizeListener", void 0), y(h(D), "container", void 0), y(h(D), "maskClickListener", void 0), y(h(D), "ticksTo1970", void 0), y(h(D), "componentDidMount", function () {
        if (D.props.autoFocus) {
          var e, t;
          null === (t = D.inputElement) || void 0 === t || null === (e = t.focus) || void 0 === e || e.call(t);
        }
        D.props.tooltip && D.renderTooltip(), D.props.inline && D.initFocusableCell(), D.props.value && D.updateInputfield(D.props.value);
      }), y(h(D), "componentDidUpdate", function (e) {
        if (e.tooltip !== D.props.tooltip && (D.tooltip ? D.tooltip.updateContent(D.props.tooltip) : D.renderTooltip()), !D.props.onViewDateChange && !D.viewStateChanged) {
          var t = D.props.value;
          Array.isArray(t) && (t = t[0]);
          var n = e.value;
          if (Array.isArray(n) && (n = n[0]), !n && t || t && t instanceof Date && n instanceof Date && t.getTime() !== n.getTime()) {
            var r = D.props.viewDate && D.isValidDate(D.props.viewDate) ? D.props.viewDate : t && D.isValidDate(t) ? t : new Date();
            D.setState({
              viewDate: r
            }, function () {
              D.viewStateChanged = !0;
            });
          }
        }
        D.panel && D.updateFocus(), e.value === D.props.value || D.state.focused || D.viewStateChanged && D.state.overlayVisible || D.updateInputfield(D.props.value);
      }), y(h(D), "componentWillUnmount", function () {
        D.mask && (D.disableModality(), D.mask = null), D.tooltip && (D.tooltip.destroy(), D.tooltip = null), D.unbindDocumentClickListener(), D.unbindDocumentResizeListener(), D.scrollHandler && (D.scrollHandler.destroy(), D.scrollHandler = null);
      }), y(h(D), "renderTooltip", function () {
        D.tooltip = p({
          target: D.inputElement,
          content: D.props.tooltip,
          options: D.props.tooltipOptions
        });
      }), y(h(D), "getDateFormat", function () {
        return D.props.dateFormat || m("dateFormat", D.props.locale);
      }), y(h(D), "onInputFocus", function (e) {
        D.ignoreFocusFunctionality ? D.setState({
          focused: !0
        }, function () {
          D.ignoreFocusFunctionality = !1;
        }) : (e.persist(), D.props.showOnFocus && !D.state.overlayVisible && D.showOverlay(), D.setState({
          focused: !0
        }, function () {
          D.props.onFocus && D.props.onFocus(e);
        }));
      }), y(h(D), "onInputBlur", function (e) {
        e.persist(), D.setState({
          focused: !1
        }, function () {
          D.props.onBlur && D.props.onBlur(e);
        });
        var t = D.props.value;
        "" === t && (t = null), D.isValidDate(t) || (t = D.props.timeOnly ? D.parseGluedTime(D.props.value, new Date()) : D.props.showTime ? D.parseGluedDateTime(D.props.value) : D.parseGluedDate(D.props.value), D.isValidDate(t) || (t = null), null !== t && "" !== t && D.updateViewDate(e, t), D.updateModel(e, t)), D.updateInputfield(t);
      }), y(h(D), "onInputKeyDown", function (e) {
        switch (D.isKeydown = !0, e.which) {
          case 27:
            D.hideOverlay();
            break;
          case 9:
            D.state.overlayVisible && D.trapFocus(e), D.props.touchUI && D.disableModality();
        }
      }), y(h(D), "onUserInput", function (e) {
        if (D.isKeydown) {
          D.isKeydown = !1;
          var t = e.target.value;
          try {
            var n = D.parseValueFromString(t);
            D.isValidSelection(n) && (D.updateModel(e, n), D.updateViewDate(e, Array.isArray(n) ? n[0] : n));
          } catch (n) {
            D.updateModel(e, t);
          }
          D.props.onInput && D.props.onInput(e);
        }
      }), y(h(D), "reFocusInputField", function () {
        !D.props.inline && D.inputElement && (D.ignoreFocusFunctionality = !0, D.inputElement.focus());
      }), y(h(D), "onButtonClick", function (e) {
        e.preventDefault(), D.props.disabled || (D.state.overlayVisible ? D.hideOverlay() : D.showOverlay());
      }), y(h(D), "onPrevButtonClick", function (e) {
        D.navigation = {
          backward: !0,
          button: !0
        }, D.navBackward(e);
      }), y(h(D), "onNextButtonClick", function (e) {
        D.navigation = {
          backward: !1,
          button: !0
        }, D.navForward(e);
      }), y(h(D), "updateFocus", function () {
        var e;
        if (D.navigation) {
          if (D.navigation.button) D.initFocusableCell(), D.navigation.backward ? l.findSingle(D.panel, ".datepicker-prev").focus() : l.findSingle(D.panel, ".datepicker-next").focus();else {
            if (D.navigation.backward) {
              var t = l.find(D.panel, ".datepicker__calendar td span:not(.datepicker--disabled)");
              e = t[t.length - 1];
            } else e = l.findSingle(D.panel, ".datepicker__calendar td span:not(.datepicker--disabled)");
            e && (e.tabIndex = 0, e.focus());
          }
          D.navigation = null;
        } else D.initFocusableCell();
      }), y(h(D), "initFocusableCell", function () {
        var e;
        if ("month" === D.view) {
          var t = l.find(D.panel, ".datepicker__monthpicker .datepicker__monthpicker-month"),
            n = l.findSingle(D.panel, ".datepicker__monthpicker .datepicker__monthpicker-month.datepicker--highlight");
          t.forEach(function (e) {
            return e.tabIndex = -1;
          }), e = n || t[0];
        } else !(e = l.findSingle(D.panel, "span.datepicker--highlight")) && (e = l.findSingle(D.panel, "td.datepicker-today span:not(.datepicker--disabled)") || l.findSingle(D.panel, ".datepicker__calendar td span:not(.datepicker--disabled)"));
        e && (e.tabIndex = 0);
      }), y(h(D), "onMonthDropdownChange", function (e) {
        var t = D.getViewDate(),
          n = new Date(t.getTime());
        n.setMonth(parseInt(e.target.value, 10)), D.updateViewDate(e, n);
      }), y(h(D), "onYearDropdownChange", function (e) {
        var t = D.getViewDate(),
          n = new Date(t.getTime());
        n.setFullYear(parseInt(e.target.value, 10)), D.updateViewDate(e, n);
      }), y(h(D), "onTodayButtonClick", function (e) {
        var t = new Date(),
          n = {
            day: t.getDate(),
            month: t.getMonth(),
            year: t.getFullYear(),
            today: !0,
            selectable: !0
          },
          r = {
            hours: t.getHours(),
            minutes: t.getMinutes(),
            seconds: t.getSeconds(),
            milliseconds: t.getMilliseconds()
          };
        D.updateViewDate(e, t), D.onDateSelect(e, n, r), D.props.onTodayButtonClick && D.props.onTodayButtonClick(e);
      }), y(h(D), "onClearButtonClick", function (e) {
        D.updateModel(e, null), D.updateInputfield(null), D.hideOverlay(D.reFocusInputField), D.props.onClearButtonClick && D.props.onClearButtonClick(e);
      }), y(h(D), "onTimePickerElementMouseDown", function (e, t, n) {
        D.props.disabled || (D.repeat(e, null, t, n), e.preventDefault());
      }), y(h(D), "onTimePickerElementMouseUp", function () {
        D.props.disabled || D.clearTimePickerTimer();
      }), y(h(D), "onTimePickerElementMouseLeave", function () {
        D.props.disabled || D.clearTimePickerTimer();
      }), y(h(D), "repeat", function (e, t, n, r) {
        e.persist();
        var a = t || 500;
        switch (D.clearTimePickerTimer(), D.timePickerTimer = window.setTimeout(function () {
          D.repeat(e, 100, n, r);
        }, a), n) {
          case 0:
            1 === r ? D.incrementHour(e) : D.decrementHour(e);
            break;
          case 1:
            1 === r ? D.incrementMinute(e) : D.decrementMinute(e);
            break;
          case 2:
            1 === r ? D.incrementSecond(e) : D.decrementSecond(e);
            break;
          case 3:
            1 === r ? D.incrementMilliSecond(e) : D.decrementMilliSecond(e);
        }
      }), y(h(D), "clearTimePickerTimer", function () {
        D.timePickerTimer && clearTimeout(D.timePickerTimer);
      }), y(h(D), "incrementHour", function (e) {
        var t = D.props.value && D.props.value instanceof Date ? D.props.value : D.getViewDate(),
          n = t.getHours() + D.props.stepHour;
        n = n >= 24 ? n - 24 : n, D.validateHour(n, t) && (D.props.maxDate && D.props.maxDate.toDateString() === t.toDateString() && D.props.maxDate.getHours() === n ? D.props.maxDate.getMinutes() < t.getMinutes() ? D.props.maxDate.getSeconds() < t.getSeconds() ? D.props.maxDate.getMilliseconds() < t.getMilliseconds() ? D.updateTime(e, n, D.props.maxDate.getMinutes(), D.props.maxDate.getSeconds(), D.props.maxDate.getMilliseconds()) : D.updateTime(e, n, D.props.maxDate.getMinutes(), D.props.maxDate.getSeconds(), t.getMilliseconds()) : D.updateTime(e, n, D.props.maxDate.getMinutes(), t.getSeconds(), t.getMilliseconds()) : D.props.maxDate.getMinutes() === t.getMinutes() ? D.props.maxDate.getSeconds() < t.getSeconds() ? D.props.maxDate.getMilliseconds() < t.getMilliseconds() ? D.updateTime(e, n, D.props.maxDate.getMinutes(), D.props.maxDate.getSeconds(), D.props.maxDate.getMilliseconds()) : D.updateTime(e, n, D.props.maxDate.getMinutes(), D.props.maxDate.getSeconds(), t.getMilliseconds()) : D.updateTime(e, n, D.props.maxDate.getMinutes(), t.getSeconds(), t.getMilliseconds()) : D.updateTime(e, n, t.getMinutes(), t.getSeconds(), t.getMilliseconds()) : D.updateTime(e, n, t.getMinutes(), t.getSeconds(), t.getMilliseconds())), e.preventDefault();
      }), y(h(D), "decrementHour", function (e) {
        var t = D.props.value && D.props.value instanceof Date ? D.props.value : D.getViewDate(),
          n = t.getHours() - D.props.stepHour;
        n = n < 0 ? n + 24 : n, D.validateHour(n, t) && (D.props.minDate && D.props.minDate.toDateString() === t.toDateString() && D.props.minDate.getHours() === n ? D.props.minDate.getMinutes() > t.getMinutes() ? D.props.minDate.getSeconds() > t.getSeconds() ? D.props.minDate.getMilliseconds() > t.getMilliseconds() ? D.updateTime(e, n, D.props.minDate.getMinutes(), D.props.minDate.getSeconds(), D.props.minDate.getMilliseconds()) : D.updateTime(e, n, D.props.minDate.getMinutes(), D.props.minDate.getSeconds(), t.getMilliseconds()) : D.updateTime(e, n, D.props.minDate.getMinutes(), t.getSeconds(), t.getMilliseconds()) : D.props.minDate.getMinutes() === t.getMinutes() ? D.props.minDate.getSeconds() > t.getSeconds() ? D.props.minDate.getMilliseconds() > t.getMilliseconds() ? D.updateTime(e, n, D.props.minDate.getMinutes(), D.props.minDate.getSeconds(), D.props.minDate.getMilliseconds()) : D.updateTime(e, n, D.props.minDate.getMinutes(), D.props.minDate.getSeconds(), t.getMilliseconds()) : D.updateTime(e, n, D.props.minDate.getMinutes(), t.getSeconds(), t.getMilliseconds()) : D.updateTime(e, n, t.getMinutes(), t.getSeconds(), t.getMilliseconds()) : D.updateTime(e, n, t.getMinutes(), t.getSeconds(), t.getMilliseconds())), e.preventDefault();
      }), y(h(D), "incrementMinute", function (e) {
        var t = D.props.value && D.props.value instanceof Date ? D.props.value : D.getViewDate(),
          n = t.getMinutes() + D.props.stepMinute;
        n = n > 59 ? n - 60 : n, D.validateMinute(n, t) && (D.props.maxDate && D.props.maxDate.toDateString() === t.toDateString() && D.props.maxDate.getMinutes() === n && D.props.maxDate.getSeconds() < t.getSeconds() ? D.props.maxDate.getMilliseconds() < t.getMilliseconds() ? D.updateTime(e, t.getHours(), n, D.props.maxDate.getSeconds(), D.props.maxDate.getMilliseconds()) : D.updateTime(e, t.getHours(), n, D.props.maxDate.getSeconds(), t.getMilliseconds()) : D.updateTime(e, t.getHours(), n, t.getSeconds(), t.getMilliseconds())), e.preventDefault();
      }), y(h(D), "decrementMinute", function (e) {
        var t = D.props.value && D.props.value instanceof Date ? D.props.value : D.getViewDate(),
          n = t.getMinutes() - D.props.stepMinute;
        n = n < 0 ? n + 60 : n, D.validateMinute(n, t) && (D.props.minDate && D.props.minDate.toDateString() === t.toDateString() && D.props.minDate.getMinutes() === n && D.props.minDate.getSeconds() > t.getSeconds() ? D.props.minDate.getMilliseconds() > t.getMilliseconds() ? D.updateTime(e, t.getHours(), n, D.props.minDate.getSeconds(), D.props.minDate.getMilliseconds()) : D.updateTime(e, t.getHours(), n, D.props.minDate.getSeconds(), t.getMilliseconds()) : D.updateTime(e, t.getHours(), n, t.getSeconds(), t.getMilliseconds())), e.preventDefault();
      }), y(h(D), "incrementSecond", function (e) {
        var t = D.props.value && D.props.value instanceof Date ? D.props.value : D.getViewDate(),
          n = t.getSeconds() + D.props.stepSecond;
        n = n > 59 ? n - 60 : n, D.validateSecond(n, t) && (D.props.maxDate && D.props.maxDate.toDateString() === t.toDateString() && D.props.maxDate.getSeconds() === n && D.props.maxDate.getMilliseconds() < t.getMilliseconds() ? D.updateTime(e, t.getHours(), t.getMinutes(), n, D.props.maxDate.getMilliseconds()) : D.updateTime(e, t.getHours(), t.getMinutes(), n, t.getMilliseconds())), e.preventDefault();
      }), y(h(D), "decrementSecond", function (e) {
        var t = D.props.value && D.props.value instanceof Date ? D.props.value : D.getViewDate(),
          n = t.getSeconds() - D.props.stepSecond;
        n = n < 0 ? n + 60 : n, D.validateSecond(n, t) && (D.props.minDate && D.props.minDate.toDateString() === t.toDateString() && D.props.minDate.getSeconds() === n && D.props.minDate.getMilliseconds() > t.getMilliseconds() ? D.updateTime(e, t.getHours(), t.getMinutes(), n, D.props.minDate.getMilliseconds()) : D.updateTime(e, t.getHours(), t.getMinutes(), n, t.getMilliseconds())), e.preventDefault();
      }), y(h(D), "incrementMilliSecond", function (e) {
        var t = D.props.value && D.props.value instanceof Date ? D.props.value : D.getViewDate(),
          n = t.getMilliseconds() + D.props.stepMillisec;
        n = n > 999 ? n - 1e3 : n, D.validateMillisecond(n, t) && D.updateTime(e, t.getHours(), t.getMinutes(), t.getSeconds(), n), e.preventDefault();
      }), y(h(D), "decrementMilliSecond", function (e) {
        var t = D.props.value && D.props.value instanceof Date ? D.props.value : D.getViewDate(),
          n = t.getMilliseconds() - D.props.stepMillisec;
        n = n < 0 ? n + 999 : n, D.validateMillisecond(n, t) && D.updateTime(e, t.getHours(), t.getMinutes(), t.getSeconds(), n), e.preventDefault();
      }), y(h(D), "toggleAmPm", function (e) {
        var t = D.props.value && D.props.value instanceof Date ? D.props.value : D.getViewDate(),
          n = t.getHours();
        D.updateTime(e, n >= 12 ? n - 12 : n + 12, t.getMinutes(), t.getSeconds(), t.getMilliseconds()), e.preventDefault();
      }), y(h(D), "getViewDate", function () {
        return D.props.onViewDateChange ? D.props.viewDate : D.state.viewDate;
      }), y(h(D), "isValidDate", function (e) {
        return e instanceof Date && !isNaN(e.getTime());
      }), y(h(D), "validateHour", function (e, t) {
        var n = !0,
          r = t ? t.toDateString() : null;
        return D.props.minDate && r && D.props.minDate.toDateString() === r && D.props.minDate.getHours() > e && (n = !1), D.props.maxDate && r && D.props.maxDate.toDateString() === r && D.props.maxDate.getHours() < e && (n = !1), n;
      }), y(h(D), "validateMinute", function (e, t) {
        var n = !0,
          r = t ? t.toDateString() : null;
        return D.props.minDate && r && D.props.minDate.toDateString() === r && t.getHours() === D.props.minDate.getHours() && D.props.minDate.getMinutes() > e && (n = !1), D.props.maxDate && r && D.props.maxDate.toDateString() === r && t.getHours() === D.props.maxDate.getHours() && D.props.maxDate.getMinutes() < e && (n = !1), n;
      }), y(h(D), "validateSecond", function (e, t) {
        var n = !0,
          r = t ? t.toDateString() : null;
        return D.props.minDate && r && D.props.minDate.toDateString() === r && t.getHours() === D.props.minDate.getHours() && t.getMinutes() === D.props.minDate.getMinutes() && D.props.minDate.getSeconds() > e && (n = !1), D.props.maxDate && r && D.props.maxDate.toDateString() === r && t.getHours() === D.props.maxDate.getHours() && t.getMinutes() === D.props.maxDate.getMinutes() && D.props.maxDate.getSeconds() < e && (n = !1), n;
      }), y(h(D), "validateMillisecond", function (e, t) {
        var n = !0,
          r = t ? t.toDateString() : null;
        return D.props.minDate && r && D.props.minDate.toDateString() === r && t.getHours() === D.props.minDate.getHours() && t.getSeconds() === D.props.minDate.getSeconds() && t.getMinutes() === D.props.minDate.getMinutes() && D.props.minDate.getMilliseconds() > e && (n = !1), D.props.maxDate && r && D.props.maxDate.toDateString() === r && t.getHours() === D.props.maxDate.getHours() && t.getSeconds() === D.props.maxDate.getSeconds() && t.getMinutes() === D.props.maxDate.getMinutes() && D.props.maxDate.getMilliseconds() < e && (n = !1), n;
      }), y(h(D), "updateTime", function (e, t, n, r, a) {
        var o = D.props.value && D.props.value instanceof Date ? new Date(D.props.value) : new Date();
        o.setHours(t), o.setMinutes(n), o.setSeconds(r), o.setMilliseconds(a), D.updateModel(e, o), D.props.onSelect && D.props.onSelect({
          originalEvent: e,
          value: o
        }), D.updateInputfield(o);
      }), y(h(D), "updateViewDate", function (e, t) {
        if (D.props.yearNavigator) {
          var n = t.getFullYear();
          D.props.minDate && D.props.minDate.getFullYear() > n && (n = D.props.minDate.getFullYear()), D.props.maxDate && D.props.maxDate.getFullYear() < n && (n = D.props.maxDate.getFullYear()), t.setFullYear(n);
        }
        if (D.props.monthNavigator && "month" !== D.props.view) {
          var r = t.getMonth(),
            a = D.isInMinYear(t) && Math.max(D.props.minDate.getMonth(), r) || D.isInMaxYear(t) && Math.min(D.props.maxDate.getMonth(), r) || r;
          t.setMonth(a);
        }
        D.props.onViewDateChange ? D.props.onViewDateChange({
          originalEvent: e,
          value: t
        }) : (D.viewStateChanged = !0, D.setState({
          viewDate: t
        }));
      }), y(h(D), "onDateCellKeydown", function (e, t, n) {
        var r = e.currentTarget,
          a = r.parentElement;
        switch (e.which) {
          case 40:
            r.tabIndex = -1;
            var o = l.index(a),
              i = a.parentElement.nextElementSibling;
            if (i) {
              var s = i.children[o].children[0];
              l.hasClass(s, "datepicker--disabled") ? (D.navigation = {
                backward: !1
              }, D.navForward(e)) : (i.children[o].children[0].tabIndex = 0, i.children[o].children[0].focus());
            } else D.navigation = {
              backward: !1
            }, D.navForward(e);
            e.preventDefault();
            break;
          case 38:
            r.tabIndex = -1;
            var p = l.index(a),
              u = a.parentElement.previousElementSibling;
            if (u) {
              var c = u.children[p].children[0];
              l.hasClass(c, "datepicker--disabled") ? (D.navigation = {
                backward: !0
              }, D.navBackward(e)) : (c.tabIndex = 0, c.focus());
            } else D.navigation = {
              backward: !0
            }, D.navBackward(e);
            e.preventDefault();
            break;
          case 37:
            r.tabIndex = -1;
            var d = a.previousElementSibling;
            if (d) {
              var m = d.children[0];
              l.hasClass(m, "datepicker--disabled") ? D.navigateToMonth(!0, n, e) : (m.tabIndex = 0, m.focus());
            } else D.navigateToMonth(!0, n, e);
            e.preventDefault();
            break;
          case 39:
            r.tabIndex = -1;
            var g = a.nextElementSibling;
            if (g) {
              var f = g.children[0];
              l.hasClass(f, "datepicker--disabled") ? D.navigateToMonth(!1, n, e) : (f.tabIndex = 0, f.focus());
            } else D.navigateToMonth(!1, n, e);
            e.preventDefault();
            break;
          case 13:
            D.onDateSelect(e, t), e.preventDefault();
            break;
          case 27:
            D.hideOverlay(D.reFocusInputField), e.preventDefault();
            break;
          case 9:
            D.trapFocus(e);
        }
      }), y(h(D), "navigateToMonth", function (e, t, n) {
        if (e) {
          if (1 === D.props.numberOfMonths || 0 === t) D.navigation = {
            backward: !0
          }, D.navBackward(n);else {
            var r = D.panel.children[t - 1],
              a = l.find(r, ".datepicker__calendar td span:not(.datepicker--disabled)"),
              o = a[a.length - 1];
            o.tabIndex = 0, o.focus();
          }
        } else if (1 === D.props.numberOfMonths || t === D.props.numberOfMonths - 1) D.navigation = {
          backward: !1
        }, D.navForward(n);else {
          var i = D.panel.children[t + 1],
            s = l.findSingle(i, ".datepicker__calendar td span:not(.datepicker--disabled)");
          s.tabIndex = 0, s.focus();
        }
      }), y(h(D), "onMonthCellKeydown", function (e, t) {
        var n = e.currentTarget;
        switch (e.which) {
          case 38:
          case 40:
            n.tabIndex = -1;
            var r = n.parentElement.children,
              a = l.index(n),
              o = r[40 === e.which ? a + 3 : a - 3];
            o && (o.tabIndex = 0, o.focus()), e.preventDefault();
            break;
          case 37:
            n.tabIndex = -1;
            var i = n.previousElementSibling;
            i && (i.tabIndex = 0, i.focus()), e.preventDefault();
            break;
          case 39:
            n.tabIndex = -1;
            var s = n.nextElementSibling;
            s && (s.tabIndex = 0, s.focus()), e.preventDefault();
            break;
          case 13:
            D.onMonthSelect(e, t), e.preventDefault();
            break;
          case 27:
            D.hideOverlay(D.reFocusInputField), e.preventDefault();
            break;
          case 9:
            D.trapFocus(e);
        }
      }), y(h(D), "onDateSelect", function (e, t, n) {
        if (D.props.disabled || !("selectable" in t) || !t.selectable) {
          e.preventDefault();
          return;
        }
        if (l.find(D.panel, ".datepicker__calendar td span:not(.datepicker--disabled)").forEach(function (e) {
          return e.tabIndex = -1;
        }), e.currentTarget.focus(), D.isMultipleSelection()) {
          if (D.isSelected(t)) {
            var r = D.props.value.filter(function (e) {
              return !D.isDateEquals(e, t);
            });
            D.updateModel(e, r);
          } else D.props.maxDateCount && D.props.value && !(D.props.maxDateCount > D.props.value.length) || D.selectDate(e, t, n);
        } else D.selectDate(e, t, n);
        !D.props.inline && D.isSingleSelection() && (!D.props.showTime || D.props.hideOnDateTimeSelect) && (setTimeout(function () {
          D.hideOverlay();
        }, 100), D.mask && D.disableModality()), e.preventDefault();
      }), y(h(D), "selectTime", function (e, t) {
        if (D.props.showTime) {
          if (t) n = t.hours, r = t.minutes, a = t.seconds, o = t.milliseconds;else {
            var n,
              r,
              a,
              o,
              i,
              s = D.props.value && D.props.value instanceof Date ? D.props.value : new Date();
            n = (i = [s.getHours(), s.getMinutes(), s.getSeconds(), s.getMilliseconds()])[0], r = i[1], a = i[2], o = i[3];
          }
          e.setHours(n), e.setMinutes(r), e.setSeconds(a), e.setMilliseconds(o);
        }
      }), y(h(D), "selectDate", function (e, t, n) {
        var r = t instanceof Date ? t : new Date(t.year, t.month, t.day);
        D.selectTime(r, n), D.props.minDate && D.props.minDate > r && (r = D.props.minDate), D.props.maxDate && D.props.maxDate < r && (r = D.props.maxDate);
        var a = r;
        if (D.isSingleSelection()) D.updateModel(e, r);else if (D.isMultipleSelection()) a = D.props.value ? E(D.props.value).concat([r]) : [r], D.updateModel(e, a);else if (D.isRangeSelection()) {
          if (Array.isArray(D.props.value) && D.props.value.length > 1) {
            var o = D.props.value[0],
              i = D.props.value[1];
            !i && r.getTime() >= o.getTime() ? i = r : (o = r, i = null), a = [o, i], D.updateModel(e, a);
          } else a = [r, null], D.updateModel(e, a);
        }
        D.props.onSelect && D.props.onSelect({
          originalEvent: e,
          value: r
        }), D.updateInputfield(a);
      }), y(h(D), "onMonthSelect", function (e, t) {
        D.onDateSelect(e, {
          year: D.getViewDate().getFullYear(),
          month: t,
          day: 1,
          selectable: !0
        }), e.preventDefault();
      }), y(h(D), "updateModel", function (e, t) {
        D.props.onChange && (D.props.onChange({
          originalEvent: e,
          value: t,
          stopPropagation: function stopPropagation() {},
          preventDefault: function preventDefault() {},
          target: {
            name: D.props.name,
            id: D.id,
            value: t
          }
        }), D.viewStateChanged = !0);
      }), y(h(D), "showOverlay", function () {
        D.setState({
          overlayVisible: !0
        });
      }), y(h(D), "hideOverlay", function (e) {
        D.setState({
          overlayVisible: !1
        }, function () {
          D.viewStateChanged = !1, D.ignoreFocusFunctionality = !1, e && e();
        });
      }), y(h(D), "onOverlayEnter", function () {
        D.props.autoZIndex && (D.panel.style.zIndex = String(D.props.baseZIndex + l.generateZIndex())), D.alignOverlay();
      }), y(h(D), "onOverlayEntered", function () {
        D.bindDocumentClickListener(), D.bindDocumentResizeListener(), D.bindScrollListener();
      }), y(h(D), "onOverlayExit", function () {
        D.unbindDocumentClickListener(), D.unbindDocumentResizeListener(), D.unbindScrollListener();
      }), y(h(D), "bindDocumentClickListener", function () {
        D.documentClickListener || (D.documentClickListener = function (e) {
          D.state.overlayVisible && D.isOutsideClicked(e) && D.hideOverlay();
        }, document.addEventListener("mousedown", D.documentClickListener));
      }), y(h(D), "unbindDocumentClickListener", function () {
        D.documentClickListener && (document.removeEventListener("mousedown", D.documentClickListener), D.documentClickListener = null);
      }), y(h(D), "bindDocumentResizeListener", function () {
        D.documentResizeListener || D.props.touchUI || (D.documentResizeListener = D.onWindowResize.bind(h(D)), window.addEventListener("resize", D.documentResizeListener));
      }), y(h(D), "unbindDocumentResizeListener", function () {
        D.documentResizeListener && (window.removeEventListener("resize", D.documentResizeListener), D.documentResizeListener = null);
      }), y(h(D), "bindScrollListener", function () {
        D.scrollHandler || (D.scrollHandler = new d(D.container, function () {
          D.state.overlayVisible && D.hideOverlay();
        })), D.scrollHandler.bindScrollListener();
      }), y(h(D), "unbindScrollListener", function () {
        D.scrollHandler && D.scrollHandler.unbindScrollListener();
      }), y(h(D), "isOutsideClicked", function (e) {
        return D.container && !(D.container.isSameNode(e.target) || D.isNavIconClicked(e) || D.container.contains(e.target) || D.panel && D.panel.contains(e.target));
      }), y(h(D), "isNavIconClicked", function (e) {
        return l.hasClass(e.target, "datepicker-prev") || l.hasClass(e.target, "datepicker-prev__icon") || l.hasClass(e.target, "datepicker-next") || l.hasClass(e.target, "datepicker-next__icon");
      }), y(h(D), "onWindowResize", function () {
        D.state.overlayVisible && !l.isAndroid() && D.hideOverlay();
      }), y(h(D), "alignOverlay", function () {
        D.props.touchUI ? D.enableModality() : (D.props.appendTo ? (l.absolutePosition(D.panel, D.inputElement), D.panel.style.minWidth = l.getWidth(D.container) + "px") : l.relativePosition(D.panel, D.inputElement), D.moveVertically(D.panel.style));
      }), y(h(D), "moveVertically", function (e) {
        var t = e.transformOrigin.includes("top");
        e.transform = t ? "translateY(4px)" : "translateY(-4px)";
      }), y(h(D), "enableModality", function () {
        D.mask || (D.mask = document.createElement("div"), D.mask.style.zIndex = String(parseInt(D.panel.style.zIndex, 10) - 1), l.addMultipleClasses(D.mask, "datepicker-mask datepicker-mask-scrollblocker"), D.maskClickListener = function () {
          D.disableModality();
        }, D.mask.addEventListener("click", D.maskClickListener), document.body.appendChild(D.mask), l.addClass(document.body, "datepicker--overflow-hidden"));
      }), y(h(D), "disableModality", function () {
        if (D.mask) {
          D.mask.removeEventListener("click", D.maskClickListener), D.maskClickListener = null, document.body.removeChild(D.mask), D.mask = null;
          for (var e, t = document.body.children, n = 0; n < t.length; n++) {
            var r = t[n];
            if (l.hasClass(r, "datepicker-mask-scrollblocker")) {
              e = !0;
              break;
            }
          }
          e || l.removeClass(document.body, "datepicker--overflow-hidden"), D.hideOverlay();
        }
      }), y(h(D), "getFirstDayOfMonthIndex", function (e, t) {
        var n = new Date();
        n.setDate(1), n.setMonth(e), n.setFullYear(t);
        var r = n.getDay() + D.getSundayIndex();
        return r >= 7 ? r - 7 : r;
      }), y(h(D), "getDaysCountInMonth", function (e, t) {
        return 32 - D.daylightSavingAdjust(new Date(t, e, 32)).getDate();
      }), y(h(D), "getDaysCountInPrevMonth", function (e, t) {
        var n = D.getPreviousMonthAndYear(e, t);
        return D.getDaysCountInMonth(n.month, n.year);
      }), y(h(D), "daylightSavingAdjust", function (e) {
        return e ? (e.setHours(e.getHours() > 12 ? e.getHours() + 2 : 0), e) : null;
      }), y(h(D), "getPreviousMonthAndYear", function (e, t) {
        var n, r;
        return 0 === e ? (n = 11, r = t - 1) : (n = e - 1, r = t), {
          month: n,
          year: r
        };
      }), y(h(D), "getNextMonthAndYear", function (e, t) {
        var n, r;
        return 11 === e ? (n = 0, r = t + 1) : (n = e + 1, r = t), {
          month: n,
          year: r
        };
      }), y(h(D), "getSundayIndex", function () {
        var e = m("firstDayOfWeek", D.props.locale);
        return e > 0 ? 7 - e : 0;
      }), y(h(D), "createWeekDays", function () {
        for (var e = [], t = g(D.props.locale), n = t.firstDayOfWeek, r = t.dayNamesMin, a = 0; a < 7; a++) e.push(r[n]), n = 6 === n ? 0 : ++n;
        return e;
      }), y(h(D), "createMonths", function (e, t) {
        for (var n = [], r = 0; r < D.props.numberOfMonths; r++) {
          var a = e + r,
            o = t;
          a > 11 && (a = a % 11 - 1, o = t + 1), n.push(D.createMonth(a, o));
        }
        return n;
      }), y(h(D), "createMonth", function (e, t) {
        for (var n = [], r = D.getFirstDayOfMonthIndex(e, t), a = D.getDaysCountInMonth(e, t), o = D.getDaysCountInPrevMonth(e, t), i = 1, s = new Date(), l = [], p = Math.ceil((a + r) / 7), u = 0; u < p; u++) {
          var c = [];
          if (0 === u) {
            for (var d = o - r + 1; d <= o; d++) {
              var m = D.getPreviousMonthAndYear(e, t);
              c.push({
                day: d,
                month: m.month,
                year: m.year,
                otherMonth: !0,
                today: D.isToday(s, d, m.month, m.year),
                selectable: D.isSelectable(d, m.month, m.year, !0)
              });
            }
            for (var g = 7 - c.length, f = 0; f < g; f++) c.push({
              day: i,
              month: e,
              year: t,
              today: D.isToday(s, i, e, t),
              selectable: D.isSelectable(i, e, t, !1)
            }), i++;
          } else for (var v = 0; v < 7; v++) {
            if (i > a) {
              var h = D.getNextMonthAndYear(e, t);
              c.push({
                day: i - a,
                month: h.month,
                year: h.year,
                otherMonth: !0,
                today: D.isToday(s, i - a, h.month, h.year),
                selectable: D.isSelectable(i - a, h.month, h.year, !0)
              });
            } else c.push({
              day: i,
              month: e,
              year: t,
              today: D.isToday(s, i, e, t),
              selectable: D.isSelectable(i, e, t, !1)
            });
            i++;
          }
          D.props.showWeek && l.push(D.getWeekNumber(new Date(c[0].year, c[0].month, c[0].day))), n.push(c);
        }
        return {
          month: e,
          year: t,
          dates: n,
          weekNumbers: l
        };
      }), y(h(D), "getWeekNumber", function (e) {
        var t = new Date(e.getTime());
        t.setDate(t.getDate() + 4 - (t.getDay() || 7));
        var n = t.getTime();
        return t.setMonth(0), t.setDate(1), Math.floor(Math.round((n - t.getTime()) / 864e5) / 7) + 1;
      }), y(h(D), "isSelectable", function (e, t, n, r) {
        var a = !0,
          o = !0,
          i = !0,
          s = !0,
          l = !0;
        return D.props.minDate && (D.props.minDate.getFullYear() > n ? a = !1 : D.props.minDate.getFullYear() === n && (D.props.minDate.getMonth() > t ? a = !1 : D.props.minDate.getMonth() === t && D.props.minDate.getDate() > e && (a = !1))), D.props.maxDate && (D.props.maxDate.getFullYear() < n ? o = !1 : D.props.maxDate.getFullYear() === n && (D.props.maxDate.getMonth() < t ? o = !1 : D.props.maxDate.getMonth() === t && D.props.maxDate.getDate() < e && (o = !1))), D.props.disabledDates && (i = !D.isDateDisabled(e, t, n)), D.props.disabledDays && (s = !D.isDayDisabled(e, t, n)), !1 === D.props.selectOtherMonths && r && (l = !1), a && o && i && s && l;
      }), y(h(D), "isSelectableTime", function (e) {
        var t = !0,
          n = !0;
        return D.props.minDate && D.props.minDate.toDateString() === e.toDateString() && (D.props.minDate.getHours() > e.getHours() ? t = !1 : D.props.minDate.getHours() === e.getHours() && (D.props.minDate.getMinutes() > e.getMinutes() ? t = !1 : D.props.minDate.getMinutes() === e.getMinutes() && (D.props.minDate.getSeconds() > e.getSeconds() ? t = !1 : D.props.minDate.getSeconds() === e.getSeconds() && D.props.minDate.getMilliseconds() > e.getMilliseconds() && (t = !1)))), D.props.maxDate && D.props.maxDate.toDateString() === e.toDateString() && (D.props.maxDate.getHours() < e.getHours() ? n = !1 : D.props.maxDate.getHours() === e.getHours() && (D.props.maxDate.getMinutes() < e.getMinutes() ? n = !1 : D.props.maxDate.getMinutes() === e.getMinutes() && (D.props.maxDate.getSeconds() < e.getSeconds() ? n = !1 : D.props.maxDate.getSeconds() === e.getSeconds() && D.props.maxDate.getMilliseconds() < e.getMilliseconds() && (n = !1)))), t && n;
      }), y(h(D), "isSelected", function (e) {
        if (!D.props.value) return !1;
        if (D.isSingleSelection()) return D.isDateEquals(D.props.value, e);
        if (D.isMultipleSelection()) {
          var t = !1,
            n = !0,
            r = !1,
            a = void 0;
          try {
            for (var o, i = D.props.value[Symbol.iterator](); !(n = (o = i.next()).done); n = !0) {
              var s = o.value;
              if (t = D.isDateEquals(s, e)) break;
            }
          } catch (e) {
            r = !0, a = e;
          } finally {
            try {
              n || null == i.return || i.return();
            } finally {
              if (r) throw a;
            }
          }
          return t;
        }
        if (D.isRangeSelection() && Array.isArray(D.props.value)) return D.props.value[1] ? D.isDateEquals(D.props.value[0], e) || D.isDateEquals(D.props.value[1], e) || D.isDateBetween(D.props.value[0], D.props.value[1], e) : D.isDateEquals(D.props.value[0], e);
      }), y(h(D), "isMonthSelected", function (e) {
        var t = D.getViewDate();
        return !!D.props.value && D.props.value instanceof Date && 1 === D.props.value.getDate() && D.props.value.getMonth() === e && D.props.value.getFullYear() === t.getFullYear();
      }), y(h(D), "isDateEquals", function (e, t) {
        return !!e && e instanceof Date && e.getDate() === t.day && e.getMonth() === t.month && e.getFullYear() === t.year;
      }), y(h(D), "isDateBetween", function (e, t, n) {
        if (e && t) {
          var r = new Date(n.year, n.month, n.day);
          return e.getTime() <= r.getTime() && t.getTime() >= r.getTime();
        }
        return !1;
      }), y(h(D), "isSingleSelection", function () {
        return "single" === D.props.selectionMode;
      }), y(h(D), "isRangeSelection", function () {
        return "range" === D.props.selectionMode;
      }), y(h(D), "isMultipleSelection", function () {
        return "multiple" === D.props.selectionMode;
      }), y(h(D), "isToday", function (e, t, n, r) {
        return e.getDate() === t && e.getMonth() === n && e.getFullYear() === r;
      }), y(h(D), "isDateDisabled", function (e, t, n) {
        if (D.props.disabledDates) for (var r = 0; r < D.props.disabledDates.length; r++) {
          var a = D.props.disabledDates[r];
          if (a.getFullYear() === n && a.getMonth() === t && a.getDate() === e) return !0;
        }
        return !1;
      }), y(h(D), "isDayDisabled", function (e, t, n) {
        if (D.props.disabledDays) {
          var r = new Date(n, t, e).getDay();
          return -1 !== D.props.disabledDays.indexOf(r);
        }
        return !1;
      }), y(h(D), "updateInputfield", function (e) {
        if (D.inputElement) {
          var t = "";
          if (e) try {
            if (D.isSingleSelection()) t = D.isValidDate(e) ? D.formatDateTime(e) : e;else if (D.isMultipleSelection()) for (var n = 0; n < e.length; n++) {
              var r = e[n],
                a = D.isValidDate(r) ? D.formatDateTime(r) : "";
              t += a, n !== e.length - 1 && (t += ", ");
            } else if (D.isRangeSelection() && e && e.length) {
              var o = e[0],
                i = e[1];
              t = D.isValidDate(o) ? D.formatDateTime(o) : "", i && (t += D.isValidDate(i) ? " - " + D.formatDateTime(i) : "");
            }
          } catch (n) {
            t = e;
          }
          D.inputElement.value = t;
        }
      }), y(h(D), "formatDateTime", function (e) {
        var t = null;
        return e && (D.props.timeOnly ? t = D.formatTime(e) : (t = D.formatDate(e, D.getDateFormat()), D.props.showTime && (t += " " + D.formatTime(e)))), t;
      }), y(h(D), "formatDate", function (e, t) {
        if (!e) return "";
        var n,
          r = function r(e) {
            var r = n + 1 < t.length && t.charAt(n + 1) === e;
            return r && n++, r;
          },
          a = function a(e, t, n) {
            var a = "" + t;
            if (r(e)) for (; a.length < n;) a = "0" + a;
            return a;
          },
          o = function o(e, t, n, a) {
            return r(e) ? a[t] : n[t];
          },
          i = "",
          s = !1,
          l = g(D.props.locale),
          p = l.dayNamesShort,
          u = l.dayNames,
          c = l.monthNamesShort,
          d = l.monthNames;
        if (e) for (n = 0; n < t.length; n++) if (s) "'" !== t.charAt(n) || r("'") ? i += t.charAt(n) : s = !1;else switch (t.charAt(n)) {
          case "d":
            i += a("d", e.getDate(), 2);
            break;
          case "D":
            i += o("D", e.getDay(), p, u);
            break;
          case "o":
            i += a("o", Math.round((new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime() - new Date(e.getFullYear(), 0, 0).getTime()) / 864e5), 3);
            break;
          case "m":
            i += a("m", e.getMonth() + 1, 2);
            break;
          case "M":
            i += o("M", e.getMonth(), c, d);
            break;
          case "y":
            i += r("y") ? e.getFullYear() : (e.getFullYear() % 100 < 10 ? "0" : "") + e.getFullYear() % 100;
            break;
          case "@":
            i += e.getTime();
            break;
          case "!":
            i += 1e4 * e.getTime() + D.ticksTo1970;
            break;
          case "'":
            r("'") ? i += "'" : s = !0;
            break;
          default:
            i += t.charAt(n);
        }
        return i;
      }), y(h(D), "formatTime", function (e) {
        if (!e) return "";
        var t = "",
          n = e.getHours(),
          r = e.getMinutes(),
          a = e.getSeconds(),
          o = e.getMilliseconds();
        return "12" === D.props.hourFormat && n > 11 && 12 !== n && (n -= 12), "12" === D.props.hourFormat ? t += 0 === n ? 12 : n < 10 ? "0" + n : n : t += n < 10 ? "0" + n : n, t += ":" + (r < 10 ? "0" + r : r), D.props.showSeconds && (t += ":" + (a < 10 ? "0" + a : a)), D.props.showMillisec && (t += "." + (o < 100 ? (o < 10 ? "00" : "0") + o : o)), "12" === D.props.hourFormat && (t += e.getHours() > 11 ? " PM" : " AM"), t;
      }), y(h(D), "parseValueFromString", function (e) {
        if (!e || 0 === e.trim().length) return null;
        if (D.isSingleSelection()) o = D.parseDateTime(e);else if (D.isMultipleSelection()) {
          var t = e.split(",");
          o = [];
          var n = !0,
            r = !1,
            a = void 0;
          try {
            for (var o, i, s = t[Symbol.iterator](); !(n = (i = s.next()).done); n = !0) {
              var l = i.value;
              o.push(D.parseDateTime(l.trim()));
            }
          } catch (e) {
            r = !0, a = e;
          } finally {
            try {
              n || null == s.return || s.return();
            } finally {
              if (r) throw a;
            }
          }
        } else if (D.isRangeSelection()) {
          var p = e.split(" - ");
          o = [];
          for (var u = 0; u < p.length; u++) o[u] = D.parseDateTime(p[u].trim());
        }
        return o;
      }), y(h(D), "parseDateTime", function (e) {
        var t,
          n = e.split(" ");
        return D.props.timeOnly ? (t = new Date(), D.populateTime(t, n[0], n[1])) : D.props.showTime ? (t = D.parseDate(n[0], D.getDateFormat()), D.populateTime(t, n[1], n[2])) : t = D.parseDate(e, D.getDateFormat()), t;
      }), y(h(D), "populateTime", function (e, t, n) {
        if ("12" === D.props.hourFormat && "pm" !== n.toLowerCase() && "am" !== n.toLowerCase()) throw Error("Invalid Time");
        var r = D.parseTime(t, n);
        e.setHours(r.hour), e.setMinutes(r.minute), e.setSeconds(r.second), e.setMilliseconds(r.millisecond);
      }), y(h(D), "parseTime", function (e, t) {
        var n = (e = D.props.showMillisec ? e.replace(".", ":") : e).split(":"),
          r = D.props.showSeconds ? 3 : 2;
        if (r = D.props.showMillisec ? r + 1 : r, n.length !== r || 2 !== n[0].length || 2 !== n[1].length || D.props.showSeconds && 2 !== n[2].length || D.props.showMillisec && 3 !== n[3].length) throw Error("Invalid time");
        var a = parseInt(n[0], 10),
          o = parseInt(n[1], 10),
          i = D.props.showSeconds ? parseInt(n[2], 10) : null,
          s = D.props.showMillisec ? parseInt(n[3], 10) : null;
        if (!(isNaN(a) || isNaN(o) || a > 23 || o > 59 || "12" === D.props.hourFormat && a > 12 || D.props.showSeconds && (isNaN(i) || i > 59) || D.props.showMillisec && (isNaN(i) || i > 1e3))) return "12" === D.props.hourFormat && 12 === a && "am" === t.toLowerCase() && (a = 0), "12" === D.props.hourFormat && 12 !== a && "pm" === t.toLowerCase() && (a += 12), {
          hour: a,
          minute: o,
          second: i,
          millisecond: s
        };
        throw Error("Invalid time");
      }), y(h(D), "parseDate", function (e, t) {
        if (null === t || null === e) throw Error("Invalid arguments");
        if ("" === e) return null;
        var n,
          r,
          a,
          o,
          i = 0,
          s = "string" != typeof D.props.shortYearCutoff ? D.props.shortYearCutoff : new Date().getFullYear() % 100 + parseInt(D.props.shortYearCutoff, 10),
          l = -1,
          p = -1,
          u = -1,
          c = -1,
          d = !1,
          m = function m(e) {
            var r = n + 1 < t.length && t.charAt(n + 1) === e;
            return r && n++, r;
          },
          f = function f(t) {
            var n = m(t),
              r = "@" === t ? 14 : "!" === t ? 20 : "y" === t && n ? 4 : "o" === t ? 3 : 2,
              a = RegExp("^\\d{" + ("y" === t ? r : 1) + "," + r + "}"),
              o = e.substring(i).match(a);
            if (!o) throw Error("Missing number at position " + i);
            return i += o[0].length, parseInt(o[0], 10);
          },
          v = function v(t, n, r) {
            var a = -1,
              o = (m(t) ? r : n).map(function (e, t) {
                return [t, e];
              });
            o.sort(function (e, t) {
              return -(e[1].length - t[1].length);
            });
            for (var s = 0; s < o.length; s++) {
              var l = o[s][1];
              if (e.substr(i, l.length).toLowerCase() === l.toLowerCase()) {
                a = o[s][0], i += l.length;
                break;
              }
            }
            if (-1 !== a) return a + 1;
            throw Error("Unknown name at position " + i);
          },
          h = function h() {
            if (e.charAt(i) !== t.charAt(n)) throw Error("Unexpected literal at position " + i);
            i++;
          };
        "month" === D.props.view && (u = 1);
        var M = g(D.props.locale),
          y = M.dayNamesShort,
          k = M.dayNames,
          w = M.monthNamesShort,
          b = M.monthNames;
        for (n = 0; n < t.length; n++) if (d) "'" !== t.charAt(n) || m("'") ? h() : d = !1;else switch (t.charAt(n)) {
          case "d":
            u = f("d");
            break;
          case "D":
            v("D", y, k);
            break;
          case "o":
            c = f("o");
            break;
          case "m":
            p = f("m");
            break;
          case "M":
            p = v("M", w, b);
            break;
          case "y":
            l = f("y");
            break;
          case "@":
            l = (o = new Date(f("@"))).getFullYear(), p = o.getMonth() + 1, u = o.getDate();
            break;
          case "!":
            l = (o = new Date((f("!") - D.ticksTo1970) / 1e4)).getFullYear(), p = o.getMonth() + 1, u = o.getDate();
            break;
          case "'":
            m("'") ? h() : d = !0;
            break;
          default:
            h();
        }
        if (i < e.length && (a = e.substr(i), !/^\s+/.test(a))) throw Error("Extra/unparsed characters found in date: " + a);
        if (-1 === l ? l = new Date().getFullYear() : l < 100 && (l += new Date().getFullYear() - new Date().getFullYear() % 100 + (l <= s ? 0 : -100)), c > -1) for (p = 1, u = c; !(u <= (r = D.getDaysCountInMonth(l, p - 1)));) p++, u -= r;
        if ((o = D.daylightSavingAdjust(new Date(l, p - 1, u))).getFullYear() !== l || o.getMonth() + 1 !== p || o.getDate() !== u) throw Error("Invalid date");
        return o;
      }), y(h(D), "renderBackwardNavigator", function (t) {
        var n = t ? {
          onClick: D.onPrevButtonClick,
          onKeyDown: function onKeyDown(e) {
            return D.onContainerButtonKeydown(e);
          }
        } : {
          style: {
            visibility: "hidden"
          }
        };
        return e.createElement("button", w({
          type: "button",
          className: "datepicker-prev datepicker-link"
        }, n), e.createElement(f, {
          regular: !0,
          name: "chevron-left",
          className: "datepicker-prev__icon"
        }), e.createElement(u, null));
      }), y(h(D), "renderForwardNavigator", function (t) {
        var n = t ? {
          onClick: D.onNextButtonClick,
          onKeyDown: function onKeyDown(e) {
            return D.onContainerButtonKeydown(e);
          }
        } : {
          style: {
            visibility: "hidden"
          }
        };
        return e.createElement("button", w({
          type: "button",
          className: "datepicker-next datepicker-link"
        }, n), e.createElement(f, {
          regular: !0,
          name: "chevron-right",
          className: "datepicker-next__icon"
        }), e.createElement(u, null));
      }), y(h(D), "isInMinYear", function (e) {
        return D.props.minDate && D.props.minDate.getFullYear() === e.getFullYear();
      }), y(h(D), "isInMaxYear", function (e) {
        return D.props.maxDate && D.props.maxDate.getFullYear() === e.getFullYear();
      }), y(h(D), "renderTitleMonthElement", function (t) {
        var n = m("monthNames", D.props.locale);
        if (!D.props.monthNavigator || "month" === D.props.view) return e.createElement("span", {
          className: "datepicker__month"
        }, n[t]);
        var r = D.getViewDate(),
          a = r.getMonth();
        return e.createElement("select", {
          className: "datepicker__month",
          onChange: D.onMonthDropdownChange,
          value: a
        }, n.map(function (t, n) {
          return (!D.isInMinYear(r) || n >= D.props.minDate.getMonth()) && (!D.isInMaxYear(r) || n <= D.props.maxDate.getMonth()) ? e.createElement("option", {
            key: t,
            value: n
          }, t) : null;
        }));
      }), y(h(D), "renderTitleYearElement", function (t) {
        if (!D.props.yearNavigator) return e.createElement("span", {
          className: "datepicker__year"
        }, t);
        for (var n = [], r = D.props.yearRange.split(":"), a = parseInt(r[0], 10), o = parseInt(r[1], 10), i = a; i <= o; i++) n.push(i);
        var s = D.getViewDate().getFullYear();
        return e.createElement("select", {
          className: "datepicker__year",
          onChange: D.onYearDropdownChange,
          value: s
        }, n.map(function (t) {
          return D.props.minDate && D.props.minDate.getFullYear() > t || D.props.maxDate && D.props.maxDate.getFullYear() < t ? null : e.createElement("option", {
            key: t,
            value: t
          }, t);
        }));
      }), y(h(D), "renderTitle", function (t) {
        var n = D.renderTitleMonthElement(t.month),
          r = D.renderTitleYearElement(t.year);
        return e.createElement("div", {
          className: "datepicker__title"
        }, n, r);
      }), y(h(D), "renderDayNames", function (t) {
        var n = t.map(function (t) {
          return e.createElement("th", {
            key: t,
            scope: "col"
          }, e.createElement("span", null, t));
        });
        return D.props.showWeek ? [e.createElement("th", {
          scope: "col",
          key: "wn",
          className: "datepicker-weekheader datepicker--disabled"
        }, e.createElement("span", null, m("weekHeader", D.props.locale)))].concat(E(n)) : n;
      }), y(h(D), "renderDateCellContent", function (t, n, r) {
        var a = D.props.dateTemplate ? D.props.dateTemplate(t) : t.day;
        return e.createElement("span", {
          className: n,
          onClick: function onClick(e) {
            return D.onDateSelect(e, t);
          },
          onKeyDown: function onKeyDown(e) {
            return D.onDateCellKeydown(e, t, r);
          }
        }, a, e.createElement(u, null));
      }), y(h(D), "renderWeek", function (t, n, r) {
        var o = t.map(function (t) {
          var n = D.isSelected(t),
            o = a({
              "datepicker-other-month": t.otherMonth,
              "datepicker-today": t.today
            }),
            i = a({
              "datepicker--highlight": n,
              "datepicker--disabled": !t.selectable
            }),
            s = t.otherMonth && !D.props.showOtherMonths ? null : D.renderDateCellContent(t, i, r);
          return e.createElement("td", {
            key: t.day,
            className: o
          }, s);
        });
        return D.props.showWeek ? [e.createElement("td", {
          key: "wn" + n,
          className: "datepicker-weeknumber"
        }, e.createElement("span", {
          className: "datepicker--disabled"
        }, n))].concat(E(o)) : o;
      }), y(h(D), "renderDates", function (t, n) {
        return t.dates.map(function (r, a) {
          return e.createElement("tr", {
            key: a
          }, D.renderWeek(r, t.weekNumbers[a], n));
        });
      }), y(h(D), "renderDateViewGrid", function (t, n, r) {
        var a = D.renderDayNames(n),
          o = D.renderDates(t, r);
        return e.createElement("div", {
          className: "datepicker__calendar-container"
        }, e.createElement("table", {
          className: "datepicker__calendar"
        }, e.createElement("thead", null, e.createElement("tr", null, a)), e.createElement("tbody", null, o)));
      }), y(h(D), "renderMonth", function (t, n) {
        var r = D.createWeekDays(),
          a = D.renderBackwardNavigator(0 === n),
          o = D.renderForwardNavigator(1 === D.props.numberOfMonths || n === D.props.numberOfMonths - 1),
          i = D.renderTitle(t),
          s = D.renderDateViewGrid(t, r, n),
          l = D.props.headerTemplate ? D.props.headerTemplate() : null;
        return e.createElement("div", {
          key: t.month,
          className: "datepicker-group"
        }, e.createElement("div", {
          className: "datepicker__header"
        }, l, a, i, o), s);
      }), y(h(D), "renderMonths", function (t) {
        var n = t.map(function (e, t) {
          return D.renderMonth(e, t);
        });
        return e.createElement("div", {
          className: "datepicker-group-container"
        }, n);
      }), y(h(D), "renderDateView", function () {
        var t = D.getViewDate(),
          n = D.createMonths(t.getMonth(), t.getFullYear()),
          r = D.renderMonths(n);
        return e.createElement(e.Fragment, null, r);
      }), y(h(D), "renderMonthViewMonth", function (t) {
        var n = a("datepicker__monthpicker-month", {
            "datepicker--highlight": D.isMonthSelected(t)
          }),
          r = m("monthNamesShort", D.props.locale)[t];
        return e.createElement("span", {
          key: r,
          className: n,
          onClick: function onClick(e) {
            return D.onMonthSelect(e, t);
          },
          onKeyDown: function onKeyDown(e) {
            return D.onMonthCellKeydown(e, t);
          }
        }, r, e.createElement(u, null));
      }), y(h(D), "renderMonthViewMonths", function () {
        for (var e = [], t = 0; t <= 11; t++) e.push(D.renderMonthViewMonth(t));
        return e;
      }), y(h(D), "renderMonthView", function () {
        var t = D.renderBackwardNavigator(),
          n = D.renderForwardNavigator(),
          r = D.renderTitleYearElement(D.getViewDate().getFullYear()),
          a = D.renderMonthViewMonths();
        return e.createElement(e.Fragment, null, e.createElement("div", {
          className: "datepicker__header"
        }, t, n, e.createElement("div", {
          className: "datepicker__title"
        }, r)), e.createElement("div", {
          className: "datepicker__monthpicker"
        }, a));
      }), y(h(D), "renderDatePicker", function () {
        if (!D.props.timeOnly) return "date" === D.props.view ? D.renderDateView() : "month" === D.props.view ? D.renderMonthView() : null;
      }), y(h(D), "renderHourPicker", function () {
        var t = (D.props.value && D.props.value instanceof Date ? D.props.value : D.getViewDate()).getHours();
        "12" === D.props.hourFormat && (0 === t ? t = 12 : t > 11 && 12 !== t && (t -= 12));
        var n = t < 10 ? "0" + t : t;
        return e.createElement("div", {
          className: "datepicker__hour-picker"
        }, e.createElement("button", {
          type: "button",
          className: "datepicker-link",
          onMouseDown: function onMouseDown(e) {
            return D.onTimePickerElementMouseDown(e, 0, 1);
          },
          onMouseUp: D.onTimePickerElementMouseUp,
          onMouseLeave: D.onTimePickerElementMouseLeave,
          onKeyDown: function onKeyDown(e) {
            return D.onContainerButtonKeydown(e);
          }
        }, e.createElement(f, {
          regular: !0,
          name: "chevron-up"
        }), e.createElement(u, null)), e.createElement("span", null, n), e.createElement("button", {
          type: "button",
          className: "datepicker-link",
          onMouseDown: function onMouseDown(e) {
            return D.onTimePickerElementMouseDown(e, 0, -1);
          },
          onMouseUp: D.onTimePickerElementMouseUp,
          onMouseLeave: D.onTimePickerElementMouseLeave,
          onKeyDown: function onKeyDown(e) {
            return D.onContainerButtonKeydown(e);
          }
        }, e.createElement(f, {
          regular: !0,
          name: "chevron-down"
        }), e.createElement(u, null)));
      }), y(h(D), "renderMinutePicker", function () {
        var t = (D.props.value && D.props.value instanceof Date ? D.props.value : D.getViewDate()).getMinutes(),
          n = t < 10 ? "0" + t : t;
        return e.createElement("div", {
          className: "datepicker__minute-picker"
        }, e.createElement("button", {
          type: "button",
          className: "datepicker-link",
          onMouseDown: function onMouseDown(e) {
            return D.onTimePickerElementMouseDown(e, 1, 1);
          },
          onMouseUp: D.onTimePickerElementMouseUp,
          onMouseLeave: D.onTimePickerElementMouseLeave,
          onKeyDown: function onKeyDown(e) {
            return D.onContainerButtonKeydown(e);
          }
        }, e.createElement(f, {
          regular: !0,
          name: "chevron-up"
        }), e.createElement(u, null)), e.createElement("span", null, n), e.createElement("button", {
          type: "button",
          className: "datepicker-link",
          onMouseDown: function onMouseDown(e) {
            return D.onTimePickerElementMouseDown(e, 1, -1);
          },
          onMouseUp: D.onTimePickerElementMouseUp,
          onMouseLeave: D.onTimePickerElementMouseLeave,
          onKeyDown: function onKeyDown(e) {
            return D.onContainerButtonKeydown(e);
          }
        }, e.createElement(f, {
          regular: !0,
          name: "chevron-down"
        }), e.createElement(u, null)));
      }), y(h(D), "renderSecondPicker", function () {
        if (D.props.showSeconds) {
          var t = (D.props.value && D.props.value instanceof Date ? D.props.value : D.getViewDate()).getSeconds(),
            n = t < 10 ? "0" + t : t;
          return e.createElement("div", {
            className: "datepicker__second-picker"
          }, e.createElement("button", {
            type: "button",
            className: "datepicker-link",
            onMouseDown: function onMouseDown(e) {
              return D.onTimePickerElementMouseDown(e, 2, 1);
            },
            onMouseUp: D.onTimePickerElementMouseUp,
            onMouseLeave: D.onTimePickerElementMouseLeave,
            onKeyDown: function onKeyDown(e) {
              return D.onContainerButtonKeydown(e);
            }
          }, e.createElement(f, {
            regular: !0,
            name: "chevron-up"
          }), e.createElement(u, null)), e.createElement("span", null, n), e.createElement("button", {
            type: "button",
            className: "datepicker-link",
            onMouseDown: function onMouseDown(e) {
              return D.onTimePickerElementMouseDown(e, 2, -1);
            },
            onMouseUp: D.onTimePickerElementMouseUp,
            onMouseLeave: D.onTimePickerElementMouseLeave,
            onKeyDown: function onKeyDown(e) {
              return D.onContainerButtonKeydown(e);
            }
          }, e.createElement(f, {
            regular: !0,
            name: "chevron-down"
          }), e.createElement(u, null)));
        }
        return null;
      }), y(h(D), "renderMiliSecondPicker", function () {
        if (D.props.showMillisec) {
          var t = (D.props.value && D.props.value instanceof Date ? D.props.value : D.getViewDate()).getMilliseconds(),
            n = t < 100 ? (t < 10 ? "00" : "0") + t : t;
          return e.createElement("div", {
            className: "datepicker-millisecond-picker"
          }, e.createElement("button", {
            type: "button",
            className: "datepicker-link",
            onMouseDown: function onMouseDown(e) {
              return D.onTimePickerElementMouseDown(e, 3, 1);
            },
            onMouseUp: D.onTimePickerElementMouseUp,
            onMouseLeave: D.onTimePickerElementMouseLeave,
            onKeyDown: function onKeyDown(e) {
              return D.onContainerButtonKeydown(e);
            }
          }, e.createElement(f, {
            regular: !0,
            name: "chevron-up"
          }), e.createElement(u, null)), e.createElement("span", null, n), e.createElement("button", {
            type: "button",
            className: "datepicker-link",
            onMouseDown: function onMouseDown(e) {
              return D.onTimePickerElementMouseDown(e, 3, -1);
            },
            onMouseUp: D.onTimePickerElementMouseUp,
            onMouseLeave: D.onTimePickerElementMouseLeave,
            onKeyDown: function onKeyDown(e) {
              return D.onContainerButtonKeydown(e);
            }
          }, e.createElement(f, {
            regular: !0,
            name: "chevron-down"
          }), e.createElement(u, null)));
        }
        return null;
      }), y(h(D), "renderAmPmPicker", function () {
        if ("12" === D.props.hourFormat) {
          var t = (D.props.value && D.props.value instanceof Date ? D.props.value : D.getViewDate()).getHours();
          return e.createElement("div", {
            className: "datepicker__ampm-picker"
          }, e.createElement("button", {
            type: "button",
            className: "datepicker-link",
            onClick: D.toggleAmPm
          }, e.createElement(f, {
            regular: !0,
            name: "chevron-up"
          }), e.createElement(u, null)), e.createElement("span", null, t > 11 ? "PM" : "AM"), e.createElement("button", {
            type: "button",
            className: "datepicker-link",
            onClick: D.toggleAmPm
          }, e.createElement(f, {
            regular: !0,
            name: "chevron-down"
          }), e.createElement(u, null)));
        }
        return null;
      }), y(h(D), "renderSeparator", function (t) {
        return e.createElement("div", {
          className: "datepicker__separator"
        }, e.createElement("span", null, t));
      }), y(h(D), "renderTimePicker", function () {
        return D.props.showTime || D.props.timeOnly ? e.createElement("div", {
          className: "datepicker__timepicker"
        }, D.renderHourPicker(), D.renderSeparator(":"), D.renderMinutePicker(), D.props.showSeconds && D.renderSeparator(":"), D.renderSecondPicker(), D.props.showMillisec && D.renderSeparator("."), D.renderMiliSecondPicker(), "12" === D.props.hourFormat && D.renderSeparator(":"), D.renderAmPmPicker()) : null;
      }), y(h(D), "renderInputElement", function () {
        return D.props.inline ? null : e.createElement(r, {
          ref: function ref(e) {
            return D.inputElement = n.findDOMNode(e);
          },
          id: D.props.inputId,
          name: D.props.name,
          type: "text",
          className: D.props.inputClassName,
          style: D.props.inputStyle,
          readOnly: D.props.readOnlyInput,
          disabled: D.props.disabled,
          required: D.props.required,
          autoComplete: "off",
          placeholder: D.props.placeholder,
          onInput: D.onUserInput,
          onFocus: D.onInputFocus,
          onBlur: D.onInputBlur,
          onKeyDown: D.onInputKeyDown,
          "aria-labelledby": D.props.ariaLabelledBy,
          inputMode: "none",
          autoSelect: D.props.autoSelect,
          hasError: !!D.props.errorMessage
        });
      }), y(h(D), "renderButton", function () {
        return D.props.showIcon ? e.createElement(f, {
          regular: !0,
          name: D.props.icon ? D.props.icon : D.props.timeOnly ? "clock" : "calendar-alt",
          className: "datepicker-trigger",
          onClick: D.props.disabled ? void 0 : D.onButtonClick
        }) : null;
      }), y(h(D), "renderButtonBar", function () {
        if (D.props.showButtonBar) {
          var t = a("datepicker-button-text", D.props.todayButtonClassName),
            n = a("datepicker-button-text", D.props.clearButtonClassName),
            r = g(D.props.locale),
            o = r.today,
            s = r.clear;
          return e.createElement("div", {
            className: "datepicker-buttonbar"
          }, e.createElement(i, {
            type: "button",
            label: o,
            onClick: D.onTodayButtonClick,
            onKeyDown: function onKeyDown(e) {
              return D.onContainerButtonKeydown(e);
            },
            className: t
          }), e.createElement(i, {
            type: "button",
            label: s,
            onClick: D.onClearButtonClick,
            onKeyDown: function onKeyDown(e) {
              return D.onContainerButtonKeydown(e);
            },
            className: n
          }));
        }
        return null;
      }), y(h(D), "renderFooter", function () {
        if (D.props.footerTemplate) {
          var t = D.props.footerTemplate();
          return e.createElement("div", {
            className: "datepicker-footer"
          }, t);
        }
        return null;
      }), y(h(D), "render", function () {
        var t = a("kaseya-ui-calendar", D.props.className),
          r = a("calendar__wrapper", {
            "calendar--has-icon": D.props.showIcon,
            "calendar--timeonly": D.props.timeOnly,
            "calendar--error": D.props.errorMessage
          }),
          i = a("kaseya-ui-datepicker__wrapper", D.props.panelClassName, {
            "datepicker--inline": D.props.inline,
            "datepicker--disabled": D.props.disabled,
            "datepicker--timeonly": D.props.timeOnly,
            "datepicker--multiple-month": D.props.numberOfMonths > 1,
            datepicker__monthpicker: "month" === D.props.view,
            "datepicker--touch-ui": D.props.touchUI
          }),
          l = D.renderInputElement(),
          p = D.renderButton(),
          u = D.renderDatePicker(),
          c = D.renderTimePicker(),
          d = D.renderButtonBar(),
          m = D.renderFooter();
        return e.createElement(o, b(w({}, D.props.containerAttributes), {
          id: D.id,
          className: t,
          value: D.props.label,
          errorMessage: D.props.errorMessage,
          isRequired: D.props.required
        }), e.createElement("span", {
          ref: function ref(e) {
            return D.container = e;
          },
          className: r
        }, l, p, e.createElement(v, {
          classNames: "datepicker__connected-overlay",
          in: D.props.inline || D.state.overlayVisible,
          timeout: {
            enter: 120,
            exit: 100
          },
          unmountOnExit: !0,
          onEnter: D.onOverlayEnter,
          onEntered: D.onOverlayEntered,
          onExit: D.onOverlayExit
        }, e.createElement(s, b(w({}, D.props.panelContainerAttributes), {
          ref: function ref(e) {
            return D.panel = n.findDOMNode(e);
          },
          className: i,
          style: D.props.panelStyle,
          appendTo: D.props.appendTo
        }), u, c, d, m))));
      }), D.state = {
        focused: !1,
        overlayVisible: !1
      }, !D.props.onViewDateChange) {
        var D,
          M = D.props.value;
        Array.isArray(M) && (M = M[0]);
        var k = D.props.viewDate && D.isValidDate(D.props.viewDate) ? D.props.viewDate : M && D.isValidDate(M) ? M : new Date();
        D.state = b(w({}, D.state), {
          viewDate: k
        });
      }
      return D.navigation = null, D.id = D.props.id || c(), D;
    }
    return T = [{
      key: "parseGluedTime",
      value: function value(e, t) {
        if ("" === e || null == e || null === t) return null;
        e = e.toUpperCase();
        var n = 0,
          r = 0,
          a = "AM";
        if (e.includes("AM") ? e = e.split("AM")[0] : e.includes("PM") && (e = e.split("PM")[0], a = "PM"), (e = e.trim()).includes(":")) n = e.split(":")[0] ? parseInt(e.split(":")[0], 10) : 0, r = e.split(":")[1] ? parseInt(e.split(":")[1], 10) : 0;else switch ((e = e.replace(/[^0-9]/g, "")).length) {
          case 4:
            n = parseInt(e[0] + e[1], 10), r = parseInt(e[2] + e[3], 10);
            break;
          case 3:
            n = parseInt(e[0], 10), r = parseInt(e[1] + e[2], 10);
            break;
          case 2:
          case 1:
            n = parseInt(e[0] + (e[1] || ""), 10), r = 0;
            break;
          default:
            return null;
        }
        return n < 0 || n >= 24 || r < 0 || r > 59 ? null : ("PM" === a && (n = n < 12 ? 12 + n : n), t.setHours(n), t.setMinutes(r), t);
      }
    }, {
      key: "parseGluedDate",
      value: function value(e) {
        var t,
          n,
          r,
          a = new Date();
        if ("" === e || null == e || !((e = e.replace(/[^a-zA-Z0-9]/g, "")).length > 5) || !(e.length < 9)) return null;
        var o = parseInt(e[0] + e[1], 10),
          i = parseInt(e[2] + e[3], 10);
        if (o >= 32 || i >= 32 || (t = o, n = i, ("mm/dd/yy" === this.props.dateFormat || null === this.props.dateFormat) && (n = o, t = i), r = e.substring(4, e.length), n > 12 && t >= 13)) return null;
        if (n > 12 && t < 13) {
          var s = n;
          n = t, t = s;
        }
        if (3 === r.toString().length) return null;
        if (2 === r.toString().length) {
          var l = Number(r);
          l >= 0 && l <= 80 ? r = parseInt("20" + r[0] + r[1]) : l >= 80 && l <= 99 && (r = parseInt("19" + r));
        }
        return a.setMonth(n - 1), a.setDate(t), a.setFullYear(r), a;
      }
    }, {
      key: "parseGluedDateTime",
      value: function value(e) {
        if ("" === e || null == e) return null;
        var t = (e = e.toUpperCase()).split(" "),
          n = t[0],
          r = t[1],
          a = this.parseGluedDate(n);
        return this.parseGluedTime(r, a);
      }
    }, {
      key: "isValidSelection",
      value: function value(e) {
        var t = this,
          n = !0;
        return this.isSingleSelection() ? this.isSelectable(e.getDate(), e.getMonth(), e.getFullYear(), !1) && this.isSelectableTime(e) || (n = !1) : Array.isArray(e) && e.every(function (e) {
          return t.isSelectable(e.getDate(), e.getMonth(), e.getFullYear(), !1) && t.isSelectableTime(e);
        }) && this.isRangeSelection() && (n = e.length > 1 && e[1] > e[0]), n;
      }
    }, {
      key: "onContainerButtonKeydown",
      value: function value(e) {
        switch (e.which) {
          case 9:
            this.trapFocus(e);
            break;
          case 27:
            this.hideOverlay(this.reFocusInputField), e.preventDefault();
        }
      }
    }, {
      key: "trapFocus",
      value: function value(e) {
        e.preventDefault();
        var t = l.getFocusableElements(this.panel);
        if (t && t.length > 0) {
          if (document.activeElement) {
            var n = t.indexOf(document.activeElement);
            e.shiftKey ? -1 === n || 0 === n ? t[t.length - 1].focus() : t[n - 1].focus() : -1 === n || n === t.length - 1 ? t[0].focus() : t[n + 1].focus();
          } else t[0].focus();
        }
      }
    }, {
      key: "navBackward",
      value: function value(e) {
        if (this.props.disabled) {
          e.preventDefault();
          return;
        }
        var t = new Date(this.getViewDate().getTime());
        if (t.setDate(1), "date" === this.props.view) 0 === t.getMonth() ? (t.setMonth(11), t.setFullYear(t.getFullYear() - 1)) : t.setMonth(t.getMonth() - 1);else if ("month" === this.props.view) {
          var n = t.getFullYear() - 1;
          if (this.props.yearNavigator) {
            var r = parseInt(this.props.yearRange.split(":")[0], 10);
            n < r && (n = r);
          }
          t.setFullYear(n);
        }
        this.updateViewDate(e, t), e.preventDefault();
      }
    }, {
      key: "navForward",
      value: function value(e) {
        if (this.props.disabled) {
          e.preventDefault();
          return;
        }
        var t = new Date(this.getViewDate().getTime());
        if (t.setDate(1), "date" === this.props.view) 11 === t.getMonth() ? (t.setMonth(0), t.setFullYear(t.getFullYear() + 1)) : t.setMonth(t.getMonth() + 1);else if ("month" === this.props.view) {
          var n = t.getFullYear() + 1;
          if (this.props.yearNavigator) {
            var r = parseInt(this.props.yearRange.split(":")[1], 10);
            n > r && (n = r);
          }
          t.setFullYear(n);
        }
        this.updateViewDate(e, t), e.preventDefault();
      }
    }], M(F.prototype, T), x && M(F, x), F;
  }(t);
y(I, "defaultProps", {
  inline: !1,
  selectionMode: "single",
  required: !1,
  readOnlyInput: !1,
  disabled: !1,
  showIcon: !0,
  showOnFocus: !1,
  autoSelect: !1,
  numberOfMonths: 1,
  view: "date",
  touchUI: !1,
  showTime: !1,
  timeOnly: !1,
  showSeconds: !1,
  showMillisec: !1,
  hourFormat: "24",
  stepHour: 1,
  stepMinute: 1,
  stepSecond: 1,
  stepMillisec: 1,
  shortYearCutoff: "+10",
  hideOnDateTimeSelect: !1,
  showWeek: !1,
  monthNavigator: !1,
  yearNavigator: !1,
  showOtherMonths: !0,
  selectOtherMonths: !0,
  showButtonBar: !1,
  todayButtonClassName: "datepicker__button-secondary",
  clearButtonClassName: "datepicker__button-secondary",
  autoZIndex: !0,
  baseZIndex: 0,
  autoFocus: !1
});
export { I as Calendar };